import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as createProjectStatus from "./createProjectStatus";
import * as removeProjectStatus from "./removeProjectStatus";
import * as retrieveProjectStatuses from "./retrieveProjectStatuses";
import * as editProjectStatus from "./editProjectStatus";

const initialState: State = {
  createProjectStatus: createProjectStatus.initialState,
  removeProjectStatus: removeProjectStatus.initialState,
  retrieveProjectStatuses: retrieveProjectStatuses.initialState,
  editProjectStatus: editProjectStatus.initialState,
};

const reduceState = combineStateReducer(initialState, {
  createProjectStatus: createProjectStatus.reduceState,
  removeProjectStatus: removeProjectStatus.reduceState,
  retrieveProjectStatuses: retrieveProjectStatuses.reduceState,
  editProjectStatus: editProjectStatus.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...createProjectStatus.createSelector(() => getState().createProjectStatus),
    ...removeProjectStatus.createSelector(() => getState().removeProjectStatus),
    ...retrieveProjectStatuses.createSelector(
      () => getState().retrieveProjectStatuses,
    ),
    ...editProjectStatus.createSelector(() => getState().editProjectStatus),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
